/** Corporate IAM chrome. Almost none of this was in Contentful. */
const dictionary = {
  "en": {
    "corporateSettings": "Corporate Settings",
    "companyInfo": "Company info",
    "creditsConsumption": "Credits consumption",
    "identityAndAccess": "Identity and Access Management",
    "allCorporateUsers": "All Corporate Users",
    "rolesAndPermissions": "Roles and Permissions",
    "assignTeams": "Assign Teams",
    "assignPools": "Assign Pools",
    "inviteNewUser": "Invite New User",
    "sendInvite": "Send Invite",
    "editUser": "Edit User",
    "deleteUser": "Delete User",
    "userRoles": "User Roles",
    "userRole": "User Role",
    "yourAccount": "Your Account",
    "notAllowed": "Not Allowed",
    "selectTeams": "Select Teams",
    "selectPools": "Select Pools",
    "assignedTeams": "Assigned Teams",
    "assignedPools": "Assigned Pools",
    "teamsAssignedOne": "{count} team assigned",
    "teamsAssignedMany": "{count} teams assigned",
    "poolsAssignedOne": "{count} pool assigned",
    "poolsAssignedMany": "{count} pools assigned",
    "refresh": "Refresh",
    "creditConsumedDate": "Credit consumed date",
    "noCreditsPeriod": "No credits consumed during the selected period.",
    "noCreditRecords": "No credit consumption records found.",
    "emptyAssignTeams": "No Team Leads, HR Managers or HR Specialists found. Please add 1 or more users with these roles first, before assigning teams.",
    "emptyAssignPools": "No Team Leads, HR Managers or HR Specialists found. Please add 1 or more users with these roles first, before assigning pools.",
    "deleteUserConfirm": "Are you sure you want to delete this user? \nNOTICE: This action cannot be undone. \nAll of this account data will be deleted. \nAnd the user will lose access to their account immediately.",
    "selectRoleHint": "Select role from dropdown to see its available permissions. Permission are",
    "nonEditable": "non editable",
    "selectUserRole": "Select User Role",
    "rolesNoteIntro": "Note:",
    "rolesNoteUsers": "Users",
    "rolesNoteUsersRest": "refers to corporate users (using the Corporate platform), whereas",
    "rolesNoteMembers": "Members",
    "rolesNoteMembersRest": "refers to employees/candidates who use the Talent platform.",
    "rolesNoteOwnerPrefix": "A company has only",
    "rolesNoteOwner": "one Owner",
    "rolesNoteOwnerRest": ", which cannot be created or modified from here.",
    "permissions": {
      "userManagement": "User Management",
      "superUsers": "Super Users (Admin)",
      "users": "Users",
      "roles": "Roles",
      "viewAll": "View All",
      "create": "Create",
      "edit": "Edit",
      "editTrailing": "Edit ",
      "delete": "Delete",
      "viewOnlyAssigned": "View Only Assigned",
      "assignHrdRole": "Assign HR Director Role",
      "assignTeamLeadRole": "Assign Team Lead Role",
      "assignSpecialistRole": "Assign HR Specialist Role",
      "assignTeamsToLeads": "Assign Teams To Team Leads",
      "teamMembers": "Team Members",
      "viewDetails": "View Details",
      "inviteToTeam": "Invite To Team",
      "removeFromTeam": "Remove From Team",
      "talentPools": "Talent Pools (Job Positions)",
      "assignPoolsToLeads": "Assign Pools To Team Leads",
      "poolMembers": "Pool Members",
      "moveMemberPoolToTeam": "Move Member From Pool To Team",
      "viewAnalytics": "View Analytics"
    },
    "toasts": {
      "loadUsersError": "Unable to load corporate users, please try again",
      "userUpdated": "User updated successfully",
      "userUpdateError": "Unable to update user, please try again",
      "userRemoved": "User removed successfully",
      "userRemoveError": "Unable to remove user, please try again",
      "inviteSent": "Invite sent to new user successfully",
      "inviteError": "Unable to invite user, please try again",
      "assignTeamsSuccess": "Save assigned teams successfully",
      "assignTeamsError": "Unable to save assigned teams, please try again",
      "assignPoolsSuccess": "Save assigned pools successfully",
      "assignPoolsError": "Unable to save assigned pools, please try again",
      "loadingCredits": "Loading credits consumption...",
      "loadCreditsError": "Unable to load credits consumption. Please try again or contact our support",
      "creditsLoaded": "Loaded {count} credit consumption record",
      "creditsLoadedPlural": "Loaded {count} credit consumption records",
      "updatingCredits": "Updating credits consumption...",
      "updateCreditsError": "Unable to update credits. Please try again or contact our support"
    }
  },
  "de": {
    "corporateSettings": "Unternehmenseinstellungen",
    "companyInfo": "Unternehmensinfo",
    "creditsConsumption": "Credits-Verbrauch",
    "identityAndAccess": "Identitäts- und Zugriffsverwaltung",
    "allCorporateUsers": "Alle Unternehmensnutzer",
    "rolesAndPermissions": "Rollen und Berechtigungen",
    "assignTeams": "Teams zuweisen",
    "assignPools": "Pools zuweisen",
    "inviteNewUser": "Neuen Nutzer einladen",
    "sendInvite": "Einladung senden",
    "editUser": "Nutzer bearbeiten",
    "deleteUser": "Nutzer löschen",
    "userRoles": "Nutzerrollen",
    "userRole": "Nutzerrolle",
    "yourAccount": "Ihr Konto",
    "notAllowed": "Nicht erlaubt",
    "selectTeams": "Teams auswählen",
    "selectPools": "Pools auswählen",
    "assignedTeams": "Zugewiesene Teams",
    "assignedPools": "Zugewiesene Pools",
    "teamsAssignedOne": "{count} Team zugewiesen",
    "teamsAssignedMany": "{count} Teams zugewiesen",
    "poolsAssignedOne": "{count} Pool zugewiesen",
    "poolsAssignedMany": "{count} Pools zugewiesen",
    "refresh": "Aktualisieren",
    "creditConsumedDate": "Datum des Credit-Verbrauchs",
    "noCreditsPeriod": "Im gewählten Zeitraum wurden keine Credits verbraucht.",
    "noCreditRecords": "Keine Credit-Verbrauchsdaten gefunden.",
    "emptyAssignTeams": "Keine Team Leads, HR Manager oder HR Specialists gefunden. Bitte fügen Sie zuerst mindestens 1 Nutzer mit diesen Rollen hinzu, bevor Sie Teams zuweisen.",
    "emptyAssignPools": "Keine Team Leads, HR Manager oder HR Specialists gefunden. Bitte fügen Sie zuerst mindestens 1 Nutzer mit diesen Rollen hinzu, bevor Sie Pools zuweisen.",
    "deleteUserConfirm": "Möchten Sie diesen Nutzer wirklich löschen? \nHINWEIS: Diese Aktion kann nicht rückgängig gemacht werden. \nAlle Daten dieses Kontos werden gelöscht. \nDer Nutzer verliert sofort den Zugriff auf das Konto.",
    "selectRoleHint": "Wählen Sie eine Rolle im Dropdown, um die verfügbaren Berechtigungen zu sehen. Berechtigungen sind",
    "nonEditable": "nicht editierbar",
    "selectUserRole": "Nutzerrolle auswählen",
    "rolesNoteIntro": "Hinweis:",
    "rolesNoteUsers": "Nutzer",
    "rolesNoteUsersRest": "bezieht sich auf Unternehmensnutzer (Corporate-Plattform), während",
    "rolesNoteMembers": "Mitglieder",
    "rolesNoteMembersRest": "sich auf Mitarbeitende/Kandidat:innen bezieht, die die Talent-Plattform nutzen.",
    "rolesNoteOwnerPrefix": "Ein Unternehmen hat nur",
    "rolesNoteOwner": "einen Owner",
    "rolesNoteOwnerRest": ", der hier nicht erstellt oder geändert werden kann.",
    "permissions": {
      "userManagement": "Nutzerverwaltung",
      "superUsers": "Super-Nutzer (Admin)",
      "users": "Nutzer",
      "roles": "Rollen",
      "viewAll": "Alle anzeigen",
      "create": "Erstellen",
      "edit": "Bearbeiten",
      "editTrailing": "Bearbeiten ",
      "delete": "Löschen",
      "viewOnlyAssigned": "Nur Zugewiesene anzeigen",
      "assignHrdRole": "HR-Director-Rolle zuweisen",
      "assignTeamLeadRole": "Team-Lead-Rolle zuweisen",
      "assignSpecialistRole": "HR-Specialist-Rolle zuweisen",
      "assignTeamsToLeads": "Teams Team Leads zuweisen",
      "teamMembers": "Teammitglieder",
      "viewDetails": "Details anzeigen",
      "inviteToTeam": "Ins Team einladen",
      "removeFromTeam": "Aus Team entfernen",
      "talentPools": "Talentpools (Pools)",
      "assignPoolsToLeads": "Pools Team Leads zuweisen",
      "poolMembers": "Pool-Mitglieder",
      "moveMemberPoolToTeam": "Mitglied vom Pool ins Team verschieben",
      "viewAnalytics": "Analysen anzeigen"
    },
    "toasts": {
      "loadUsersError": "Unternehmensnutzer konnten nicht geladen werden, bitte erneut versuchen",
      "userUpdated": "Nutzer erfolgreich aktualisiert",
      "userUpdateError": "Nutzer konnte nicht aktualisiert werden, bitte erneut versuchen",
      "userRemoved": "Nutzer erfolgreich entfernt",
      "userRemoveError": "Nutzer konnte nicht entfernt werden, bitte erneut versuchen",
      "inviteSent": "Einladung an neuen Nutzer erfolgreich gesendet",
      "inviteError": "Nutzer konnte nicht eingeladen werden, bitte erneut versuchen",
      "assignTeamsSuccess": "Zugewiesene Teams erfolgreich gespeichert",
      "assignTeamsError": "Zugewiesene Teams konnten nicht gespeichert werden, bitte erneut versuchen",
      "assignPoolsSuccess": "Zugewiesene Pools erfolgreich gespeichert",
      "assignPoolsError": "Zugewiesene Pools konnten nicht gespeichert werden, bitte erneut versuchen",
      "loadingCredits": "Credit-Verbrauch wird geladen...",
      "loadCreditsError": "Credit-Verbrauch konnte nicht geladen werden. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support",
      "creditsLoaded": "{count} Credit-Verbrauchseintrag geladen",
      "creditsLoadedPlural": "{count} Credit-Verbrauchseinträge geladen",
      "updatingCredits": "Credit-Verbrauch wird aktualisiert...",
      "updateCreditsError": "Credits konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support"
    }
  },
  "fi": {
    "corporateSettings": "Yrityksen asetukset",
    "companyInfo": "Yritystiedot",
    "creditsConsumption": "Krediittien käyttö",
    "identityAndAccess": "Identiteetin- ja pääsynhallinta",
    "allCorporateUsers": "Kaikki yrityksen käyttäjät",
    "rolesAndPermissions": "Roolit ja käyttöoikeudet",
    "assignTeams": "Määritä tiimit",
    "assignPools": "Määritä poolit",
    "inviteNewUser": "Kutsu uusi käyttäjä",
    "sendInvite": "Lähetä kutsu",
    "editUser": "Muokkaa käyttäjää",
    "deleteUser": "Poista käyttäjä",
    "userRoles": "Käyttäjäroolit",
    "userRole": "Käyttäjärooli",
    "yourAccount": "Tilisi",
    "notAllowed": "Ei sallittu",
    "selectTeams": "Valitse tiimit",
    "selectPools": "Valitse poolit",
    "assignedTeams": "Määritetyt tiimit",
    "assignedPools": "Määritetyt poolit",
    "teamsAssignedOne": "{count} tiimi määritetty",
    "teamsAssignedMany": "{count} tiimiä määritetty",
    "poolsAssignedOne": "{count} pooli määritetty",
    "poolsAssignedMany": "{count} poolia määritetty",
    "refresh": "Päivitä",
    "creditConsumedDate": "Krediitin käyttöpäivä",
    "noCreditsPeriod": "Valitun jakson aikana ei käytetty krediittejä.",
    "noCreditRecords": "Krediittien käyttötietoja ei löytynyt.",
    "emptyAssignTeams": "Tiiminvetäjiä, HR-päälliköitä tai HR-asiantuntijoita ei löytynyt. Lisää ensin vähintään yksi käyttäjä näillä rooleilla, ennen kuin määrität tiimejä.",
    "emptyAssignPools": "Tiiminvetäjiä, HR-päälliköitä tai HR-asiantuntijoita ei löytynyt. Lisää ensin vähintään yksi käyttäjä näillä rooleilla, ennen kuin määrität pooleja.",
    "deleteUserConfirm": "Haluatko varmasti poistaa tämän käyttäjän? HUOM: Tätä toimintoa ei voi kumota. Kaikki tilin tiedot poistetaan, ja käyttäjä menettää pääsyn tililleen välittömästi.",
    "selectRoleHint": "Valitse rooli valikosta, niin näet sen käyttöoikeudet. Käyttöoikeuksia ei voi",
    "nonEditable": "muokata",
    "selectUserRole": "Valitse käyttäjärooli",
    "rolesNoteIntro": "Huom:",
    "rolesNoteUsers": "Käyttäjät",
    "rolesNoteUsersRest": "tarkoittaa yrityskäyttäjiä (Corporate-alustan käyttäjiä), kun taas",
    "rolesNoteMembers": "Jäsenet",
    "rolesNoteMembersRest": "tarkoittaa työntekijöitä tai hakijoita, jotka käyttävät Talent-alustaa.",
    "rolesNoteOwnerPrefix": "Yrityksellä on vain",
    "rolesNoteOwner": "yksi omistaja",
    "rolesNoteOwnerRest": ", jota ei voi luoda eikä muokata täällä.",
    "permissions": {
      "userManagement": "Käyttäjien hallinta",
      "superUsers": "Pääkäyttäjät (Admin)",
      "users": "Käyttäjät",
      "roles": "Roolit",
      "viewAll": "Näytä kaikki",
      "create": "Luo",
      "edit": "Muokkaa",
      "editTrailing": "Muokkaa",
      "delete": "Poista",
      "viewOnlyAssigned": "Näytä vain määritetyt",
      "assignHrdRole": "Määritä HR-johtajan rooli",
      "assignTeamLeadRole": "Määritä tiiminvetäjän rooli",
      "assignSpecialistRole": "Määritä HR-asiantuntijan rooli",
      "assignTeamsToLeads": "Määritä tiimit tiiminvetäjille",
      "teamMembers": "Tiimin jäsenet",
      "viewDetails": "Näytä tiedot",
      "inviteToTeam": "Kutsu tiimiin",
      "removeFromTeam": "Poista tiimistä",
      "talentPools": "Osaajapoolit (tehtävät)",
      "assignPoolsToLeads": "Määritä poolit tiiminvetäjille",
      "poolMembers": "Poolin jäsenet",
      "moveMemberPoolToTeam": "Siirrä jäsen poolista tiimiin",
      "viewAnalytics": "Näytä analytiikka"
    },
    "toasts": {
      "loadUsersError": "Yrityskäyttäjien lataaminen epäonnistui, yritä uudelleen",
      "userUpdated": "Käyttäjä päivitetty",
      "userUpdateError": "Käyttäjän päivittäminen epäonnistui, yritä uudelleen",
      "userRemoved": "Käyttäjä poistettu",
      "userRemoveError": "Käyttäjän poistaminen epäonnistui, yritä uudelleen",
      "inviteSent": "Kutsu lähetetty uudelle käyttäjälle",
      "inviteError": "Käyttäjän kutsuminen epäonnistui, yritä uudelleen",
      "assignTeamsSuccess": "Määritetyt tiimit tallennettu",
      "assignTeamsError": "Määritettyjä tiimejä ei voitu tallentaa, yritä uudelleen",
      "assignPoolsSuccess": "Määritetyt poolit tallennettu",
      "assignPoolsError": "Määritettyjä pooleja ei voitu tallentaa, yritä uudelleen",
      "loadingCredits": "Ladataan krediittien käyttöä...",
      "loadCreditsError": "Krediittien käyttöä ei voitu ladata. Yritä uudelleen tai ota yhteyttä tukeemme",
      "creditsLoaded": "Krediittien käyttötietoja ladattu: {count}",
      "creditsLoadedPlural": "Krediittien käyttötietoja ladattu: {count}",
      "updatingCredits": "Päivitetään krediittien käyttöä...",
      "updateCreditsError": "Krediittejä ei voitu päivittää. Yritä uudelleen tai ota yhteyttä tukeemme"
    }
  }
};

export default dictionary;
